// Detect and return the injected wallet provider.
// Handles Trust Wallet, MetaMask, Binance Wallet, and multi-provider environments.

export function getInjectedProvider() {
  if (typeof window === 'undefined') return null;

  // Trust Wallet specific object
  if (window.trustwallet) return window.trustwallet;

  // Multi-provider (EIP-1193 providers[] array)
  if (window.ethereum && window.ethereum.providers && window.ethereum.providers.length) {
    const providers = window.ethereum.providers;
    // Prefer Trust Wallet
    const trust = providers.find((p) => p.isTrust || p.isTrustWallet);
    if (trust) return trust;
    // Then MetaMask
    const mm = providers.find((p) => p.isMetaMask && !p.isBraveWallet);
    if (mm) return mm;
    return providers[0];
  }

  if (window.ethereum) return window.ethereum;

  // Binance chain wallet
  if (window.BinanceChain) return window.BinanceChain;

  return null;
}

export function isMobile() {
  if (typeof navigator === 'undefined') return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function isTrustWallet() {
  const p = getInjectedProvider();
  return !!(p && (p.isTrust || p.isTrustWallet));
}

// Open deep link into Trust Wallet mobile app if no injected provider on mobile
export function openTrustWalletDeepLink() {
  if (typeof window === 'undefined') return;
  const host = window.location.host + window.location.pathname;
  window.location.href = `https://link.trustwallet.com/open_url?coin_id=20000714&url=https://${host}`;
}
